module.exports = __webpack_public_path__ + "img/malaysia.52c0650c.png";